/**
 * Static router configuration
 *  -  Use 'routes' key for sub routes.
 *  -  Relative paths are not (yet) supported.
 */
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { getSplitPath } from '../utils/util';
import Tenants from '../routes/Tenant/Tenants';
import Admins from '../routes/Admin/Admins';
import TenantProfile from '../routes/TenantProfile/TenantProfile';

export const routerConfig = [
  {
    path: '/tenant',
    name: 'Tenants',
    component: Tenants,
  }, {
    path: '/tenant/:id',
    name: 'Tenant Profile',
    component: TenantProfile,
  }, {
    path: '/admin',
    name: 'Admins',
    component: Admins,
  }, {
    path: '/admin/add',
    name: 'Add Admin',
    component: Admins,
  },
  {
    path: '/',
    name: 'Home',
    redirect: '/tenant',
  },
];

export const renderRoutes = routes => routes.map((route) => {
  if (route.redirect) {
    return <Redirect key={route.path} path={route.path} to={route.redirect} />;
  }

  return <Route exact key={route.path} {...route} />;
});

const getPathNameFromPath = (path) => {
  const matchRoute = routerConfig.filter(r => r.path === path);
  return matchRoute[0].name;
};

export const getPathNames = (url) => {
  const pathList = getSplitPath(url);

  return pathList.map((path) => {
    const name = getPathNameFromPath(path);
    return { path, name };
  });
};



// WEBPACK FOOTER //
// ./src/common/router.js